// creo constante q guarda la funcion de requerir archivos
const requireModule = require.context('.', true, /\.js$/);
// nombre a exportar
const watch = {
	$route(to, from) {
		this.url = to.path;
		if (this.url === to.path) {
			// reiniciando datos de paginador al cambiar url
			this.resetContadorPaginador();
			this.heightPage = window.innerHeight;
			if (this.$route.params.id > 0) {
				this.active = this.$route.params.id;
				this.id_tags = [];
				this.id_tags.push(this.$route.params.id);
				this.getJobsDash();
			} else {
					this.active = 0;
					this.id_tags = [];
					this.getJobsDash();
				}
		}
	},
};
// recorro el arbol de archivos de mi carpeta actual donde estoy ubicado
requireModule.keys().forEach(fileName => {
	// si es igual al mismo index omitir
	if (fileName === './index.js') return;
	if (fileName === './watch.js') return;
	// quito la extencion .js y declaro el nombre de la funcion o metodo segun el nombre del archivo
	const functionName = fileName.replace(/(\.\/|\.js)/g, '');
	// si aun no he creado el objeto lo inicializo
	if (!watch[functionName]) { 
		watch[functionName] = {};
	}
	// almacenar en la memoria la importacion
	//watch[functionName]= fileName;
	// console.log('file watch', fileName)
	watch[functionName] = requireModule(fileName).default
	// console.log('import watch', watch[functionName])
});
// console.log('print', watch)
export default watch
